<div>
  <app-selection-list
    class="selection-list"
    [data]="items"
    [selected]="defaultSelectAll ? items : []"
    [multiple]="true"
    (changed)="selectionChange($event)"
  >
    <ng-container *appSelectionSelectAll="let content">
      <div class="list-item-text select-all-text">
        {{ content }}
      </div>
    </ng-container>
    <ng-container *appSelectionListItem="let item">
      <div class="list-item-text">
        {{ item.name }}
      </div>
    </ng-container>
  </app-selection-list>
  <hr class="horizontal-divider"/>
  <div class="btn-container">
    <button class="btn btn-download" (click)="handleExport()">Download</button>
  </div>
</div>
